import { createReducer, on } from '@ngrx/store';
import { submitCustomizeModal } from 'ChartApp/ts/apps/scatter-plot/state/plot-options/plot-options.actions';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
export const labelPlacements = createReducer({}, on(submitCustomizeModal, (state, action) => {
    const newState = { ...state };
    const { labelPlacement, uniquePointId } = action;
    newState[uniquePointId] = labelPlacement;
    return newState;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.labelPlacements;
}));
